import { Button } from '@material-ui/core';
import { Badge } from 'antd';
import NotesIcon from 'assets/img/icon-notes-chat.svg';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { Skeleton } from 'antd';
import { Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS, TARGET_BLANK } from 'utils/constants/routes';
import { Add as AddIcon } from '@material-ui/icons';

// Skeleton component for table cells
const TableSkeleton = () => (
  <Skeleton active={true} paragraph={{ rows: 0, width: '100%' }} />
);

export const CURRENT_CLIENT_TAB_COLUMNS = () => {
  return [
    {
      title: 'Client',
      dataIndex: 'client',
      key: 'client',
      sorter: true,
      render: (text, record) => {
        const { isLoaderView } = record;

        if (isLoaderView) {
          return <TableSkeleton />;
        }

        return record.link ? (
          <Link
            className="schedule_link"
            to={ROUTE_PATHS.CLIENT_AVAILABILITY + record?.clientId}
            target={TARGET_BLANK}
            style={{
              textTransform: 'none',
              padding: 0,
              minWidth: 0,
              color: '#6f42f5',
              cursor: 'pointer'
            }}
          >
            {text}
          </Link>
        ) : (
          text
        );
      }
    },
    {
      title: 'Clinic',
      dataIndex: 'clinic',
      key: 'clinic',
      sorter: true,
      render: (text, record) => {
        const { isLoaderView } = record;

        if (isLoaderView) {
          return <TableSkeleton />;
        }

        return text;
      }
    },
    {
      title: 'Recommended',
      dataIndex: 'recommended',
      key: 'recommended',
      render: (text, record) => {
        return text;
      }
    },
    {
      title: 'Accepted Block',
      dataIndex: 'acceptedBlock',
      key: 'acceptedBlock',
      render: (text, record) => {
        const { isLoaderView } = record;

        if (isLoaderView) {
          return <TableSkeleton />;
        }

        return record.acceptedBlock.map((block, blockIndex) => (
          <div
            key={blockIndex}
            style={{
              marginBottom: blockIndex > 0 ? '8px' : '0'
            }}
          >
            {block.split('\n').map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </div>
        ));
      }
    },
    {
      title: 'Scheduled Block',
      dataIndex: 'scheduledBlock',
      key: 'scheduledBlock',
      render: (text, record) => {
        const { isLoaderView } = record;

        if (isLoaderView) {
          return <TableSkeleton />;
        }

        if (record.scheduledBlock && record.scheduledBlock.length > 0) {
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 4
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {record.scheduledBlock.map((block, blockIndex) => (
                  <div
                    key={blockIndex}
                    style={{
                      marginBottom: blockIndex > 0 ? '8px' : '0',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 4
                    }}
                  >
                    {block !== 'None' && (
                      <EventAvailableIcon
                        style={{ fontSize: 16, color: '#225C25' }}
                      />
                    )}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      {block.split('\n').map((line, i) => (
                        <div key={i}>{line}</div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        }
        return '';
      }
    },
    {
      title: 'Remaining Block',
      dataIndex: 'remainingBlock',
      key: 'remainingBlock',
      render: (text, record) => {
        const { isLoaderView } = record;

        if (isLoaderView) {
          return <TableSkeleton />;
        }

        if (record.remainingBlock && record.remainingBlock.length > 0) {
          return (
            <div>
              {record.remainingBlock.map((item, blockIndex) => {
                const blockText = typeof item === 'string' ? item : item.text;
                const opensOn = typeof item === 'string' ? undefined : item.opensOn;
                const hasNonBTBooking = typeof item === 'string' ? undefined : item.hasNonBTBooking;
                const lines = blockText.split('\n');
                const opensLabel = opensOn
                  ? ` [Opens: ${new Date(opensOn + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}]`
                  : '';
                // Only show non-BT tag if opensOn is not present
                const nonBTLabel = !opensOn && hasNonBTBooking ? ' [non-BT]' : '';
                return (
                  <div
                    key={blockIndex}
                    style={{
                      marginBottom: blockIndex < record.remainingBlock.length - 1 ? '4px' : '0'
                    }}
                  >
                    <div>{lines[0]}{opensLabel}{nonBTLabel}</div>
                    {lines.slice(1).map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        }
        return '';
      }
    },
    {
      title: 'Waitlisted Reason',
      dataIndex: 'waitlistedReason',
      key: 'waitlistedReason',
      render: (text, record) => {
        return text;
      }
    }
  ];
};
